import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useAppSelector } from "../../hooks";
import type { SubscriptionPackage } from "../../types/subscription";
import LandingNav from "../../components/Landing/LandingNav";
import HeroSection from "../../components/Landing/HeroSection";
import FeaturesSection from "../../components/Landing/FeaturesSection";
import AdvantagesSection from "../../components/Landing/AdvantagesSection";
import PricingSection from "../../components/Landing/PricingSection";
// import TestimonialsSection from "../../components/Landing/TestimonialsSection";
import CTASection from "../../components/Landing/CTASection";
import LandingFooter from "../../components/Landing/LandingFooter";

const LandingPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const authUser = useAppSelector((state) => state.auth.user);
  const activeRole = useAppSelector((state) => state.auth.activeRole);
  const hasAuthenticatedParam = searchParams.get("isAuthenticated") === "true";
  const isAuthenticated = hasAuthenticatedParam || !!authUser;

  // Redirect authenticated users to their dashboard unless they have the isAuthenticated query param
  useEffect(() => {
    if (authUser && activeRole && !hasAuthenticatedParam) {
      navigate(`/${activeRole.toLowerCase()}`, { replace: true });
    }
  }, [authUser, activeRole, hasAuthenticatedParam, navigate]);

  const handleSelectPlan = (_pkg: SubscriptionPackage) => {
    if (isAuthenticated) {
      navigate("/plans");
    } else {
      navigate("/register");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <LandingNav isAuthenticated={isAuthenticated} />
      <HeroSection isAuthenticated={isAuthenticated} activeRole={activeRole} />
      <FeaturesSection />
      <AdvantagesSection />
      <PricingSection isAuthenticated={isAuthenticated} onSelectPlan={handleSelectPlan} />
      {/* <TestimonialsSection /> */}
      <CTASection isAuthenticated={isAuthenticated} activeRole={activeRole} />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
